import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { gradients } from '../styles/design-tokens';

interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

const BASE_URL = 'https://northstaraurora.tech';

export default function PageLayout({ children, title, description }: PageLayoutProps) {
  const location = useLocation();

  useEffect(() => {
    if (title) document.title = title;
    const url = `${BASE_URL}${location.pathname}`;

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', 'content', title);
      setMeta('meta[name="twitter:title"]', 'content', title);
    }
    setMeta('meta[property="og:url"]', 'content', url);

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    // Scroll to top on navigation
    window.scrollTo(0, 0);
  }, [title, description, location.pathname]);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: gradients.background }}>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
